function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { EventEmitter, Timer, shortUUID } from "../../utils";
/**
 * This data structure represents the queue of toasts to show the user.
 *
 * It's similar to a regular queue except with some specifics related to toasts:
 * - It hides toasts after a time period and garbage collects after a longer time period
 * - It allows subscribing to queue updates
 * - It allows setting the height of toasts
 */
export var ToastQueue = /*#__PURE__*/function () {
  function ToastQueue() {
    var _this = this;
    _classCallCheck(this, ToastQueue);
    this.toasts = [];
    this.toastTimers = {};
    this.toastTTL = 8000;
    this.eventEmitter = new EventEmitter();
    this.hideToast = function (toastId) {
      _this.toasts = _this.toasts.map(function (toast) {
        if (toast.id === toastId) {
          return _objectSpread(_objectSpread({}, toast), {}, {
            show: false
          });
        }
        return toast;
      });
      _this.eventEmitter.emit('update');
      _this.eventEmitter.emit('hide', toastId);
    };
    this.setToastHeight = function (toastId, toastHeight) {
      _this.toasts = _this.toasts.map(function (toast) {
        if (toast.id === toastId) {
          return _objectSpread(_objectSpread({}, toast), {}, {
            height: toastHeight
          });
        }
        return toast;
      });
      _this.eventEmitter.emit('update');
    };
  } // Static variable for now, but we may want to allow the user to increase this
  // for a11y reasons
  // Used to allow consumers to subscribe to updates to the toast array
  _createClass(ToastQueue, [{
    key: "getAll",
    value: function getAll() {
      return this.toasts;
    }
  }, {
    key: "getAllWithHeights",
    value: function getAllWithHeights() {
      return this.toasts.filter(function (toast) {
        return typeof toast.height === 'number';
      });
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(callback) {
      return this.eventEmitter.on('update', callback);
    }
  }, {
    key: "onHide",
    value: function onHide(callback) {
      return this.eventEmitter.on('hide', callback);
    }
  }, {
    key: "areAllToastsHidden",
    value: function areAllToastsHidden() {
      return this.toasts.every(function (toast) {
        return !toast.show;
      });
    }
  }, {
    key: "push",
    value: function push(_ref) {
      var _this2 = this;
      var intent = _ref.intent,
        text = _ref.text;
      var id = "toast-".concat(shortUUID());
      this.toasts.push({
        id: id,
        intent: intent,
        text: text,
        show: true
      });
      this.eventEmitter.emit('update');

      // Hide the toast after a time specified by toastTTL.  After the toast has
      // finished animating out, the toast is removed from our internal array as a
      // garbage collection mechanism to avoid memory leaks
      this.toastTimers[id] = new Timer(function () {
        delete _this2.toastTimers[id];
        _this2.hideToast(id);

        // Garbage collect the toast after it's finished animating out
        setTimeout(function () {
          _this2.toasts = _this2.toasts.filter(function (toast) {
            return toast.id !== id;
          });
        }, 2000);
      }, this.toastTTL);
    }
  }, {
    key: "pauseAllToastDismissTimers",
    value: function pauseAllToastDismissTimers() {
      Object.values(this.toastTimers).forEach(function (timer) {
        return timer.pause();
      });
    }
  }, {
    key: "resumeAllToastDismissTimers",
    value: function resumeAllToastDismissTimers() {
      Object.values(this.toastTimers).forEach(function (timer) {
        return timer.resume();
      });
    }
  }]);
  return ToastQueue;
}();